import { VIEW_MODE_EDITOR, VIEW_MODE_SITE, VIEW_MODE_PREVIEW } from '../constants/view-modes';
export const getViewMode = state => state.viewMode;

export const isEditor = state => getViewMode(state) === VIEW_MODE_EDITOR;
export const isPreview = state => getViewMode(state) === VIEW_MODE_PREVIEW;
export const isSite = state => getViewMode(state) === VIEW_MODE_SITE;



// WEBPACK FOOTER //
// ./app/selectors/view-mode-selectors.js